export const WEENAT_ARVALIS_CLIENT_ID = 'Weenat';
export const WEENAT_ARVALIS_CONSTRUCTOR_ID = 3;
